/* eslint-disable react-hooks/exhaustive-deps */
import React, { PropsWithChildren, useCallback, useEffect, useMemo, useRef, useState } from "react";
import moment from "moment";
import "./leadDetails.css";
import ActivityItem from "../../../components/activityItem";
import LeadNoteItems from "../../../components/leadNoteItems";
import LeadStatus from "../../../components/leadStatus";
import EmptyState from "../EmptyState";
import {
  assignLeadInList,
  copyLeadInList,
  deleteBulkLeads,
  getLeadDetail,
  moveLeadInList,
  sendLeadToMobile,
  shareContentLead,
  updateLead,
  updateLeadProducts,
  uploadLeadFiles,
  deleteLeadFile,
} from "../../../services/leadService";
import ContactLinksGenerator from "../../../utils/contactlinksgenerator";
import _ from "lodash";
import LeadLabel from "../../../components/leadLabel";
import DrawerComponent from "../../../components/drawer";
import FileUpload from "../FileUpload";
import { useSelector, useDispatch } from "react-redux";
import toast from "react-hot-toast";
import {
  setActivityList,
  setNote,
  setLeadTaskList,
  leadFileList,
  updateSingleLead,
  setContentList,
} from "../../../actions/actions";

import {
  getLeadFormResponse,
} from "../../../services/formService";
import FormResponse from "../../userForm/FormResponse";
import TaskDrawer from "../../common/TaskDrawer";

import { deleteTask, taskById } from "../../../services/taskService";

import CreateActivityForm from "../../../components/createActivityForm";
import { activityById, createActivity } from "../../../services/activityService";
import GenericConfirmationModal from "../../../components/GenericConfirmationModal";
import CreateNoteForm from "../../../components/createNoteForm";
import GlobalDrawer from "../../../components/GlobalDrawer";
import { getAllLeadList } from "../../../services/leadListService";
import {
  FaExternalLinkAlt,
  FaPhone,
  FaPhoneAlt,
  FaWhatsapp,
} from "react-icons/fa";
import {
  MdEdit,
  MdOutlineAttachFile,
  MdOutlineMail,
  MdSave,
} from "react-icons/md";
import { addCountryCode, convertToIST } from "../../../utils/helpers";

import { getAllContent } from "../../../services/contentService";
import { IoIosArrowDown } from "react-icons/io";
import CreateLeadForm from "../createLeadForm";
import Information from "./Information";
import NewTaskItem from "../../../components/newTaskItem";
import { MdOutlineEdit } from "react-icons/md";
import LeadOptionsMenu from "./LeadOptionsMenu";
import LeadActionIcons from "./LeadActionIcons";
import { Edit, Pencil, ShoppingCart } from "lucide-react";
import ActivityTab from "../activitytab/ActivityTab";
import TaskForm from "../../../components/TaskForm";
import { sendLeadToAllDevices } from "../../../services/leadService";
import logger, { Logger } from '../../../utils/logger';
import ProductPickerPopup from "../../../components/ProductPickerPopup";
import AssignLeadDrawer from "../../../components/AssignLeadDrawer";
import LeadInfoPanel from "./LeadInfoPanel";
import BulkShareModal from "../../../components/BulkLeadOptions/BulkShareModal";
// Self-contained components for status/label editing
import SelectLeadStatus from "../../../components/status";
import SelectLeadLabel from "../../../components/label";
import LeadDrawerComponent from "../../../components/leadDrawer";
// TODO: WhatsApp Conversations Feature - Import commented out for release
// import LeadCommunicationPopup from "./LeadCommunicationPopup";



const MemoizedProductPickerPopup = React.memo(ProductPickerPopup);


interface LeadDataI {
  _id: string;
  leadListId?: string;
  name: string;
  integration: string;
  customSource: string;
  createdAt: Date;
  status: Array<string>;
  saleValue: string;
  website: string;
  label: Array<any>;
  // All callbacks are now optional - LeadDetails handles internally if not provided
  deleteLeadFromDrawer?: (id: string) => void;
  copyLeadToList?: () => void;
  moveLeadToList?: () => void;
  onLabelClick?: () => void;
  onStatusClick?: () => void;
  setFrom?: React.Dispatch<React.SetStateAction<string>>;
  handleEditModal?: (name: string, id: any, action: string) => void;
  handleLeadDetailsModalOpen?: (title: string, name: string) => void;
  onLeadFileUpload?: (e: any) => void;
  editLead?: (e: any, id: string) => void;
  leadFileDelete?: (obj: any) => void;
  refreshData?: () => void;
  onDeleteLead?: () => void;
}

interface ProductWithQuantity {
  _id: string;
  name: string;
  price: number;
  quantity: number;
  // Add other fields as needed
}

interface SelectedLeadI {
  activities: Array<any>;
  label: Array<any>;
  notes: Array<{
    createdAt: Date;
    createdBy: Date;
    description: string;
    lead: string;
    _id: string;
  }>;
  tasks: Array<any>;
  phone: string;
  email: string;
}


const LeadDetails: React.FC<PropsWithChildren<LeadDataI>> = ({
  _id,
  leadListId,
  name,
  integration,
  customSource,
  createdAt,
  status,
  saleValue,
  website,
  label,
  deleteLeadFromDrawer,
  copyLeadToList,
  moveLeadToList,
  onLabelClick,
  onStatusClick,
  setFrom,
  handleEditModal,
  handleLeadDetailsModalOpen,
  onLeadFileUpload,
  editLead,
  leadFileDelete,
  refreshData,
  onDeleteLead,
}) => {
  // OPTIMIZED: Use specific selectors to prevent unnecessary re-renders
  const leadFileData = useSelector((state: any) => state?.rootReducers?.leadFile?.leadFile);
  const userPreferencesLabels = useSelector((state: any) => state?.rootReducers?.user?.userPreferences?.labels);
  const leadListStore = useSelector((state: any) => state?.rootReducers?.leadList?.leadList);

  // Create a StoreData-like object for backwards compatibility
  const StoreData = {
    leadFile: { leadFile: leadFileData },
    user: { userPreferences: { labels: userPreferencesLabels } },
    leadList: { leadList: leadListStore }
  };
  const [selectedLeadData, setSelectedLeadData] = useState<SelectedLeadI>({
    activities: [],
    label: [],
    notes: [],
    tasks: [],
    phone: "",
    email: "",
  });
  const createLeadFormRef = useRef();
  const [disableLeadInfo, setDisableLeadInfo] = useState<boolean>(true);
  const [leadData, setLeadData] = useState<any>({});
  
  const [showConfirmationModal, setShowConfirmationModal] =
    useState<boolean>(false);
  
    const [isProductPickerOpen, setIsProductPickerOpen] = useState(false);
    const [selectedProducts, setSelectedProducts] = useState<ProductWithQuantity[]>([]);

const [isLoadingLists, setIsLoadingLists] = useState(false);
const [leadNotFound, setLeadNotFound] = useState(false);

const [showBulkShareModal, setShowBulkShareModal] = useState(false);
const [activeTab, setActiveTab] = useState<'activities' | 'tasks' | 'notes' | 'info'>('activities');
// TODO: WhatsApp Conversations Feature - State commented out for release
// const [showWhatsAppPopup, setShowWhatsAppPopup] = useState(false);


  const [viewFormResponse, setViewFormResponse] = useState<boolean>(false);
  const [openWithHeader, setOpenWithHeader] = useState<boolean>(false);
  const [openFileDrawer, setOpenFileDrawer] = useState<any>(false);
  const [copyLeadDrawer, setCopyLeadDrawer] = useState(false);
  const [shareLeadDrawer, setShareLeadDrawer] = useState(false);
  const [assignLeadDrawer, setAssignLeadDrawer] = useState(false);

  // ========== SELF-CONTAINED STATE ==========
  // These enable LeadDetails to work standalone without parent callbacks
  const [internalStatusPopup, setInternalStatusPopup] = useState(false);
  const [internalLabelPopup, setInternalLabelPopup] = useState(false);
  const [internalEditDrawer, setInternalEditDrawer] = useState(false);
  const [internalFileDeleteModal, setInternalFileDeleteModal] = useState(false);
  const [fileToDelete, setFileToDelete] = useState<any>(null);
  const [internalFrom, setInternalFrom] = useState<string>("");
  const [internalSelectedStatus, setInternalSelectedStatus] = useState<string>("");
  const [internalLabelData, setInternalLabelData] = useState<Array<any>>([]);
  const [internalSelectedLabel, setInternalSelectedLabel] = useState<Array<string>>([]);
  // ========== END SELF-CONTAINED STATE ==========

    // Debug logging removed to prevent performance issues
    // The previous useEffects ran on every render causing unnecessary overhead


  const contactGenerator = useMemo(() => {
    // Create a contact generator using data from leadData or selectedLeadData
    const phone = leadData?.phone || selectedLeadData?.phone || "";
    const email = leadData?.email || selectedLeadData?.email || "";
    
    return new ContactLinksGenerator({
      number: phone,
      email: email,
      message: "Hello"
    });
  }, [leadData?.phone, leadData?.email, selectedLeadData?.phone, selectedLeadData?.email]);


  const [action, setAction] = useState<string>("");
  const [taskData, setTaskData] = useState<any>({});
  const [formData, setFormData] = useState({});
  const [activityData, setActivityData] = useState<any>({});
  const dispatch = useDispatch();

  // OPTIMIZED: Use specific selectors instead of entire rootReducers
  const userDetails = useSelector((state: any) => state?.rootReducers?.userData?.userDetails);
  const leadTaskData = useSelector((state: any) => state?.rootReducers?.leadTask?.leadTask);
  const notesData = useSelector((state: any) => state?.rootReducers?.note?.notes);
  // OPTIMIZATION: Use cached content from Redux if available
  const cachedContentList = useSelector((state: any) => state?.rootReducers?.whatsapp?.content?.contentList);

  // Create a StateData-like object for backwards compatibility
  const StateData = {
    userData: { userDetails },
    leadTask: { leadTask: leadTaskData },
    note: { notes: notesData }
  };
  
  const [activeLeadOption, setActiveLeadOption] = useState("copy");
  const [leadOwnerName, setLeadOwnerName] = useState<any>("");
  const [extraDetails, setExtraDetails] = useState<any>({});

  const [leadListData, setLeadListData] = useState<any>([]);

  const [activeLeadId, setActiveLeadId] = useState("");

const [isLoadingContent, setIsLoadingContent] = useState(false);
const [contentData, setContentData] = useState<any[]>([]);

  const [contentType, setContentType] = useState("message");
  const [deleteModal, setDeleteModal] = useState<boolean>(false);

  const handleSafeClose = () => {
    // React will batch these updates automatically
    setOpenWithHeader(false);
    setAction("");
    setTaskData({});
    setActivityData({});
    
    // Only call refreshData if it exists
    if (refreshData) {
      refreshData();
    }
  };
  



 // Current code:
const teamMembers = useMemo(() => 
  StateData?.userData?.userDetails?.organizationEmployee
    ?.filter((item: any) => 
      item?._id !== StateData?.userData?.userDetails?._id && 
      item?.isActive === true
    )
    .map((item: any) => ({
      value: item?._id, 
      label: `${item?.firstName} ${item?.lastName}`,
      role: item?.role
    })), 
  [StateData?.userData?.userDetails]
);

 
const handleClosePicker = useCallback(() => {
  setIsProductPickerOpen(false);
}, []);


// Update the fetchLeadDetails function to properly handle product data
const fetchLeadDetails = useCallback(async () => {
  // Reset not found state before fetching
  setLeadNotFound(false);

  try {
    const response = await getLeadDetail(_id);

    // Handle 404 / Record not found
    if (response?.data?.statusCode === 404 || response?.data?.status === false) {
      logger.log('⚠️ Lead not found (deleted or moved):', _id);
      setLeadNotFound(true);
      return;
    }

    if (response && response.status) {
      let responseData = response?.data?.data;

      
      let leadOwnerName =
        StateData?.userData?.userDetails?.organizationEmployee?.find(
          (x: any) => x._id == responseData.createdBy
        );
      let first_name = leadOwnerName?.firstName;
      let last_name = leadOwnerName?.lastName ? leadOwnerName?.lastName : "";
     setLeadData(responseData);
      logger.log('💾 LeadDetails - Data set, passing to Information:', !!responseData);
      dispatch(setActivityList(responseData?.activities));
      dispatch(setLeadTaskList(responseData?.tasks));
      dispatch(setNote(responseData?.notes));
      dispatch(leadFileList(responseData?.files));
      setExtraDetails(responseData.extraDetails || {});
      setLeadOwnerName(first_name + " " + last_name);
      // Use functional update to avoid dependency on selectedLeadData
      setSelectedLeadData(prev => ({
        ...prev,
        activities: responseData?.activities,
        label: responseData?.label,
        notes: responseData?.notes,
        tasks: responseData?.tasks,
        phone: responseData?.phone,
        email: responseData?.email,
      }));
      
      // Set selected products from lead data if available
      if (responseData.products && responseData.products.length > 0) {
        logger.log('Setting selected products from lead data:', responseData.products);
        // Transform the products to match the ProductWithQuantity interface
        const productsWithQuantity = responseData.products.map((product: any) => {
          logger.log('Processing product in transformatoin:', {
            product,
            hasId: !!product.id,
            hasUnderscore: !!product._id
          });
          
          const productId = product.id || product._id;
          logger.log('Extracted product ID:', productId);
          
          const transformed = {
            _id: productId,
            name: product.name,
            price: parseFloat(product.price) || 0,
            quantity: parseFloat(product.quantity) || 1
          };
          
          logger.log('Transformed product:', transformed);
          return transformed;
        });
        setSelectedProducts(productsWithQuantity);
      } else {
        // Reset selected products if none in the lead data
        setSelectedProducts([]);
      }
    }
  } catch (err: any) {
    // Handle 404 errors (Axios throws error for 4xx status codes)
    if (err?.response?.status === 404 || err?.response?.data?.statusCode === 404) {
      logger.log('⚠️ Lead not found (deleted or moved):', _id);
      setLeadNotFound(true);
      return;
    }
    Logger.log(err);
    console.error('Error fetching lead details:', err);
  }
}, [_id, userDetails?.organizationEmployee, dispatch]);

  useEffect(() => {
    // Clear previous lead's data before fetching new lead
    dispatch(setActivityList([]));
    dispatch(setLeadTaskList([]));
    dispatch(setNote([]));
    dispatch(leadFileList([]));
    setLeadData({});
    setLeadNotFound(false); // Reset not found state

    // Fetch new lead details
    fetchLeadDetails();
  }, [_id]);

  // ========== SELF-CONTAINED HANDLERS ==========
  // Internal file upload handler - used when onLeadFileUpload is not provided
  const internalFileUpload = useCallback(async (e: any) => {
    logger.log("📤 Internal file upload starting");
    let formData = new FormData();
    formData.append("files", e.target.files[0]);
    formData.append("type", "lead");
    formData.append("lead", _id);

    try {
      const response = await uploadLeadFiles(formData);
      logger.log("📤 Upload complete:", response);

      if (response && response.status) {
        const tempArray = [...(StoreData?.leadFile?.leadFile || [])];
        const newItem = response.data[0];

        if (newItem) {
          tempArray.unshift(newItem);
          dispatch(leadFileList(tempArray));
          toast.success(response.message || "File uploaded successfully");
        }
      } else {
        toast.error(response?.message || "Error uploading file");
      }
    } catch (err) {
      console.error("File upload error:", err);
      toast.error("Error while uploading file!");
    }
  }, [_id, StoreData?.leadFile?.leadFile, dispatch]);

  // Internal file delete handler - used when leadFileDelete is not provided
  const internalFileDelete = useCallback(async () => {
    if (!fileToDelete) return;

    try {
      const objData = {
        type: "lead",
        lead: _id,
        filePaths: [fileToDelete.filePath],
      };
      const response = await deleteLeadFile(objData);

      if (response && response.status) {
        const tempArray = [...(StoreData?.leadFile?.leadFile || [])];
        const tempData = tempArray.findIndex((x: any) => x.filePath === fileToDelete.filePath);
        tempArray.splice(tempData, 1);
        toast.success(response?.data?.message || "File deleted successfully");
        dispatch(leadFileList(tempArray));
        setFileToDelete(null);
        setInternalFileDeleteModal(false);
      }
    } catch (err) {
      toast.error("Error while deleting file.");
    }
  }, [_id, fileToDelete, StoreData?.leadFile?.leadFile, dispatch]);

  // Internal status click handler
  const internalStatusClick = useCallback(() => {
    const currentStatus = leadData?.status?.[0] || status?.[0] || "";
    setInternalSelectedStatus(currentStatus);
    setInternalFrom("details");
    setInternalStatusPopup(true);
  }, [leadData?.status, status]);

  // Internal label click handler
  const internalLabelClick = useCallback(() => {
    // Get label preferences from Redux store OR localStorage as fallback
    let labelPreferences = StoreData?.user?.userPreferences?.labels || [];

    // Fallback to localStorage if Redux doesn't have labels
    if (!labelPreferences.length) {
      try {
        const localPrefs = localStorage.getItem("user_preferences");
        if (localPrefs) {
          const parsed = JSON.parse(localPrefs);
          labelPreferences = parsed?.labels || [];
        }
      } catch (err) {
        console.error("Error reading localStorage:", err);
      }
    }

    // Get current lead's labels from leadData or props
    const currentLabels = leadData?.label || label || [];

    // Initialize the label array with isLabelChecked based on current lead's labels
    const labelArray = labelPreferences.map((labelObj: any) => ({
      ...labelObj,
      isLabelChecked: currentLabels.includes(labelObj.value)
    }));

    // Also initialize the selected labels array with current lead's labels
    setInternalSelectedLabel(currentLabels);
    setInternalLabelData(labelArray);
    setInternalFrom("details");
    setInternalLabelPopup(true);
  }, [leadData?.label, label, StoreData?.user?.userPreferences?.labels]);

  // Internal edit lead handler
  const internalEditLead = useCallback((e: any) => {
    e?.stopPropagation?.();
    setInternalEditDrawer(true);
  }, []);

  // Internal file delete toggle (shows confirmation)
  const internalFileDeleteToggle = useCallback((objData: any) => {
    setFileToDelete(objData);
    setInternalFileDeleteModal(true);
  }, []);

  // Internal label change handler - signature matches SelectLeadLabel's expected (e, name)
  const internalLabelChange = useCallback((e: any, name?: string) => {
    if (!e?.target?.value) return;

    const Value = e.target.value;
    const newArray = [...internalSelectedLabel];
    const labelArray = [...internalLabelData];

    const tempObj = labelArray.find((x: any) => x.value === Value);
    if (tempObj) {
      tempObj.isLabelChecked = !tempObj.isLabelChecked;
    }

    if (internalSelectedLabel.includes(Value)) {
      const index = newArray.findIndex((d: string) => d === Value);
      newArray.splice(index, 1);
    } else {
      newArray.push(Value);
    }

    setInternalLabelData(labelArray);
    setInternalSelectedLabel(newArray);
  }, [internalSelectedLabel, internalLabelData]);

  // Internal status change handler
  const internalStatusChange = useCallback((e: any) => {
    setInternalSelectedStatus(e.target.value);
  }, []);
  // ========== END SELF-CONTAINED HANDLERS ==========


const handleQuickShare = useCallback(async () => {
  logger.log('🚀 Quick Share clicked - checking for cached content...');

  // OPTIMIZATION: Use cached content from Redux if available
  if (cachedContentList && cachedContentList.length > 0) {
    logger.log('✅ Using cached content from Redux:', cachedContentList.length, 'templates');
    setContentData(cachedContentList);
    setShowBulkShareModal(true);
    return;
  }

  // If no cache, fetch from API
  logger.log('📡 No cached content, fetching from API...');
  try {
    setIsLoadingContent(true);

    const response = await getAllContent({
      isAscending: false,
      page: 1,
      perPage: 500,
    });

    logger.log('📡 Content API Response:', response);

    if (response?.status) {
      logger.log('✅ Content loaded:', response.data.data.length, 'templates');
      setContentData(response.data.data);
      // Cache content in Redux for future use
      dispatch(setContentList(response.data.data));
      setShowBulkShareModal(true);
    } else {
      console.error('❌ Failed to load content');
      alert('Failed to load content templates');
    }
  } catch (error) {
    console.error('❌ Error fetching content:', error);
    alert('Error loading content templates');
  } finally {
    setIsLoadingContent(false);
  }
}, [cachedContentList, dispatch]);

  const getAllCustomFormResponse = async () => {
    try {
      const response = await getLeadFormResponse(_id);
      const formResponse = response.data.data[0];

      if (formResponse) {
        setFormData(formResponse);
        setViewFormResponse(true);
      } else {
        toast.error("Form response not found");
      }
    } catch (error) {
      console.error("Error fetching form response:", error);
      toast.error("Failed to load form response");
    }
  };

  const handleDelete = () => {
    if (action === "editTask") {
      onConfirmation(taskData?._id || "", "task");
    }
    if (action === "editActivity") {
      onConfirmation(activityData?._id || "", "activity");
    }
  };


 // In LeadDetails.tsx, update the handleProductsSelect function:
const handleProductsSelect = useCallback((products: ProductWithQuantity[]) => {
  logger.log('Products selected:', products);
  

// Calculate total value from products - use manual override if provided  
const calculatedTotal = (products as any).manualSaleValue || products.reduce((sum, p) => sum + (p.price * p.quantity), 0);
  
  // Format products array for API
  const productsForApi = products.map(p => ({
    id: p._id,
    quantity: p.quantity
  }));
  
  // Show loading toast
  const loadingToast = toast.loading("Updating lead...");
  
  // Update lead with selected products AND sale value
  updateLeadProducts(_id, productsForApi, calculatedTotal)
    .then(response => {
      toast.dismiss(loadingToast);
      toast.success("Products updated successfully");
      
      if (response?.data?.data) {
        const updatedLead = response.data.data;
        setLeadData(updatedLead);
      }
    })
    .catch(error => {
      toast.dismiss(loadingToast);
      toast.error("Failed to update products");
    })
    .finally(() => {
      // Close the product picker
      handleClosePicker();
    });
}, [_id, handleClosePicker]);
  
  const handleEditActivityModal = async (
    name: string,
    _id: any,
    action: string
  ) => {
    if (name === "activity") {
      try {
        const response = await activityById(_id);
        if (response && response.status) {
          setActivityData(response.data.data);
          setAction("editActivity");
          setOpenWithHeader(true);
        }
      } catch (err) {
        toast.error("error while fetching activity data.");
      }
    }
    if (name === "task") {
      try {
        const response = await taskById(_id);
        if (response && response.status) {
          setTaskData(response.data.data);
          setAction("editTask");
          setOpenWithHeader(true);
        }
      } catch (err) {
        toast.error("error while fetching activity data.");
      }
    }
  };

  
  const toggleConfirmationModal = () => {
    setShowConfirmationModal(!showConfirmationModal);
  };

  const handleCopyToList = useCallback(async () => {
  logger.log('📋 Copy to List clicked - fetching list data...');
  
  try {
    setIsLoadingLists(true);
    setActiveLeadOption("copy"); // Set the action type
    
    // Fetch lead lists when user clicks copy
    const response = await getAllLeadList({
      isAscending: false,
      page: 1,
      perPage: 100,
    });
    
    logger.log('📡 Lead Lists API Response:', response);
    
    if (response?.status) {
      logger.log('✅ Lead lists loaded:', response.data.data.length, 'lists');
      setLeadListData(response.data.data);
      setCopyLeadDrawer(true); // Open drawer after data is loaded
    } else {
      console.error('❌ Failed to load lead lists');
      alert('Failed to load lead lists');
    }
  } catch (error) {
    console.error('❌ Error fetching lead lists:', error);
    alert('Error loading lead lists');
  } finally {
    setIsLoadingLists(false);
  }
}, []);

const handleMoveToList = useCallback(async () => {
  logger.log('📋 Move to List clicked - fetching list data...');
  
  try {
    setIsLoadingLists(true);
    setActiveLeadOption("move"); // Set the action type
    
    // Same API call as copy, but different action
    const response = await getAllLeadList({
      isAscending: false,
      page: 1,
      perPage: 100,
    });
    
    if (response?.status) {
      logger.log('✅ Lead lists loaded for move:', response.data.data.length, 'lists');
      setLeadListData(response.data.data);
      setCopyLeadDrawer(true); // Same drawer, different action
    } else {
      alert('Failed to load lead lists');
    }
  } catch (error) {
    console.error('❌ Error fetching lead lists:', error);
    alert('Error loading lead lists');
  } finally {
    setIsLoadingLists(false);
  }
}, []);

  const onConfirmation = async (id: string, name: string) => {
    if (name === "task" && id) {
      try {
        const response = await deleteTask(id);
        if (response && response.status) {
          toast.success(response?.data?.message);
          const tempArray = [...StateData?.leadTask?.leadTask];

          const tempData = tempArray.findIndex((x) => x._id == taskData._id);
          tempArray.splice(tempData, 1);
          dispatch(setLeadTaskList(tempArray));

          setTaskData({});
          toggleConfirmationModal();
        }
      } catch (err) {
        toast.error("Error while deleting task!");
      }
      setOpenWithHeader(false);
      setAction("");
    }
    if (name === "activity" && id) {
      // try {
      //   const response = await deleteTask(id);
      //   if (response && response.status) {
      //     toast.success(response?.data?.message);
      //     handleTaskFollowup(response?.data?.data);
      //     setTaskData({});
      //   }
      // } catch (err) {
      //   toast.error("Error while deleting task!");
      // }
      setOpenWithHeader(false);
      setAction("");
    }
  };

  
  const handleTaskFollowup = useCallback((responseData?: any) => {
    if (responseData) {
      const tempArray = [...StateData?.leadTask?.leadTask];
      if (action === "addTask") {
        tempArray?.unshift(responseData?.data);
        setLeadData(responseData?.lead);
      } else {
        const tempData = tempArray.findIndex((x) => x._id == responseData.data._id);
        tempArray.splice(tempData, 1, responseData.data);
      }
      dispatch(setLeadTaskList(tempArray));
    }
  }, [action, StateData?.leadTask?.leadTask, dispatch]);

  const handleCopyLead = async (leadId: string) => {
    try {
      const data = {
        leadIDs: [leadData._id],
        targetListId: leadId === "" ? null : leadId, // Handle default list case
      };

      if (activeLeadOption == "copy") {
        const response = await copyLeadInList(data);
        toast.success(response?.data?.message);
      } else {
        const response = await moveLeadInList(data);
        toast.success(response?.data?.message);
      }
      setCopyLeadDrawer(false);
    } catch (err) {
      Logger.log();
    }
  };

  const handleAssignLead = async (leadId: string) => {
    try {
      const data = {
        leadIds: [leadData._id],
        assignToUser: leadId,
      };
      const response = await assignLeadInList(data);
      toast.success(response?.data?.message);
      setAssignLeadDrawer(false);
    } catch (err) {}
  };

 

const drawerTitle =
  action === "addTask"
    ? "Add Task"
    : action === "editTask"
    ? "Edit Task"
    : action === "addActivity"
    ? "Add Activity"
    : action === "addNotes"        // ← ADD THIS LINE
    ? "Add Notes"                  // ← ADD THIS LINE
    : action === "editActivity"
    ? "Edit Activity"
    : "Edit Activity";

  // const onScrollLeadMore = () => {
  //   // 20 more records in .5 secs
  //   // setTimeout(() => {
  //   //   setActivityData(StateData.concat(Array.from({ length: 3 })));
  //   // }, 500);
  // };
  // phoneNumber.substring(phoneNumber.length - 10)

const validateNumber = (number: string): string => {
  // Use ContactLinksGenerator's smart logic
  const contactObj = new ContactLinksGenerator({
    number: number,
    email: "",
    message: ""
  });
  
  // Extract the formatted number (remove + for WhatsApp URL)
  return contactObj._number.replace(/^\+/, '');
};

  //  Share lead
  const shareContent = async (data: any, share: string) => {
    if (data.type == "file" || data.type == "page") {
      try {
        const body = {
          contentId: data._id,
          leadIds: [_id],
          performedAt: createdAt,
          contentType: data.type,
        };
        const response = await shareContentLead(body);
        const message = `Hi ${name || ""},

          Here's the link to view new one:
          ${response.data.data.uniqueLink}`;
        if (share == "whatsapp") {
          const whatsappUrl = `https://api.whatsapp.com/send?phone=${encodeURIComponent(
            validateNumber(contactGenerator?._number || "")
          )}&text=${encodeURIComponent(message)}`;
          window.open(whatsappUrl, "_blank");
        } else {
          const subject = `Hi ${name || ""}, ${
            StateData?.userData?.userDetails?.firstName
          } ${StateData?.userData?.userDetails?.lastName} has shared ${
            data.type
          } with you`;
          const emailUrl = `mailto:${
            contactGenerator?.mail
          }?subject=${subject}&body=${encodeURIComponent(message)}`;
          window.open(emailUrl, "_blank");
        }
      } catch (err) {
        Logger.log();
      }
    } else {
      try {
        const body = {
          type: "share",
          // contentId: data._id,
          leadIds: [_id],
          performedAt: createdAt,
          // contentType: data.type
        };

        const response = await createActivity(body);
        Logger.log("response ======>", response.data.data.uniqueLink);

        const message = (
          data.details?.description || data.details?.message
        )?.replace(/@lead name/g, name || "");
        if (share == "whatsapp") {
          const whatsappUrl = `https://api.whatsapp.com/send?phone=${encodeURIComponent(
            validateNumber(contactGenerator?._number || "")
          )}&text=${encodeURIComponent(message)}`;
          window.open(whatsappUrl, "_blank");
        } else {
          const subject = `Hi ${name || ""}, ${
            StateData?.userData?.userDetails?.firstName
          } ${StateData?.userData?.userDetails?.lastName} has shared ${
            data.type
          } with you`;
          const emailUrl = `mailto:${
            contactGenerator?.mail
          }?subject=${subject}&body=${encodeURIComponent(message)}`;
          window.open(emailUrl, "_blank");
        }
      } catch (err) {
        Logger.log();
      }
    }
  };

  const handleDeleteLead = async () => {
    setDeleteModal(false); // Close the modal first
    const loadingToast = toast.loading("Deleting lead...");

    try {
      const response = await deleteBulkLeads({
        leadIDs: [_id],
      });

      toast.dismiss(loadingToast);

      // Check statusCode for success (200)
      if (response?.data?.statusCode === 200) {
        toast.success(response?.data?.message || "Lead deleted successfully");
        onDeleteLead && onDeleteLead();
      } else {
        // Show error for non-200 status codes
        toast.error(response?.data?.message || "Failed to delete lead");
      }
    } catch (err: any) {
      toast.dismiss(loadingToast);
      const errorMessage = err?.response?.data?.message || err?.message || "Error deleting lead";
      toast.error(errorMessage);
      Logger.log(err, "Error deleting lead");
    }
  };

 /**
 * Send the current lead to all mobile devices
 */
const handleSendToMobile = async () => {
  try {
    // Use the enhanced function to send to all devices
    const response = await sendLeadToAllDevices(_id, name);
    
    if (response && response.status) {
      toast.success("Lead sent to all mobile devices");
    }
  } catch (err) {
    console.error("Error sending lead to mobile:", err);
    toast.error("Failed to send lead to mobile devices");
  }
};
  



  // Add this memoized total calculation before the return statement:
const productTotal = useMemo(() => 
  selectedProducts.reduce((sum, p) => sum + (p.price * p.quantity), 0), 
  [selectedProducts]
);

  const getEmployeeInfoById = useCallback((id: string) => {
    const info = StateData?.userData?.userDetails?.organizationEmployee?.find(
      (e: any) => e._id === id
    );
    return `${info?.firstName ?? "-"}  ${info?.lastName ?? ""}` || "-";
  }, [StateData?.userData?.userDetails]);
  
  const getListInfoById = useCallback((id: string) => {
    const info = StateData?.userData?.userDetails?.organizationLeadList?.find(
      (e: any) => e._id === id
    );
    return info?.name || "-";
  }, [StateData?.userData?.userDetails]);

  // Get user role for delete permission checks (same as BulkLeadOptions)
  const userRole = StateData?.userData?.userDetails?.role?.name;
  const canDeleteLead = userRole !== 'employee'; // Hide delete button for employees

  const isDeleteable = useMemo(() =>
    StateData?.userData?.userDetails?.userPreference?.screenPermission?.includes(
      "lead_profile_screen > options_modal > delete"
    ),
    [StateData?.userData?.userDetails]
  );

    // Show message when lead is not found (deleted or moved)
    if (leadNotFound) {
      return (
        <div className="row" style={{ height: "100%" }}>
          <div className="col-12 d-flex flex-column align-items-center justify-content-center" style={{ height: "400px" }}>
            <div className="text-center">
              <div style={{ fontSize: "64px", marginBottom: "16px" }}>🔍</div>
              <h4 style={{ color: "#333", marginBottom: "12px" }}>Lead Not Found</h4>
              <p style={{ color: "#666", maxWidth: "300px" }}>
                This lead may have been deleted or moved to another list.
              </p>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="row" style={{ height: "100%" }}>
        <div className="col-md-4" style={{ paddingRight: "0" }}>
          <div className="popup-section-4-left" style={{ padding: "0px", height: "100%" }}>
          <LeadOptionsMenu
  leadId={_id}
   onCopyToList={isLoadingContent ? () => {} : () => { handleCopyToList(); }}
  onMoveToList={isLoadingContent ? () => {} : () => { handleMoveToList(); }}
  onAssignLead={() => {
    setAssignLeadDrawer(true);
  }}


onShare={isLoadingContent ? () => {} : () => { handleQuickShare(); }}


  onSendToMobile={handleSendToMobile}
  onDelete={canDeleteLead ? () => setDeleteModal(true) : undefined}
  isDeleteAllowed={canDeleteLead}
/>
        

          <div style={{ padding: "10px" }}>
            {/* Lead name - full width, truncate long names to 2 lines */}
            <h3
              className="text-capitalize text-black text-center"
              title={name || "No Name"}
              style={{
                fontSize: "15px",
                fontWeight: "700",
                fontFamily: "Gilroy-Bold",
                lineHeight: "1.3",
                margin: "0 0 6px 0",
                display: "-webkit-box",
                WebkitLineClamp: 2,
                WebkitBoxOrient: "vertical" as any,
                overflow: "hidden",
                textOverflow: "ellipsis",
                wordBreak: "break-word",
              }}
            >
              {name || "No Name"}
            </h3>

            {/* Action icons */}
            <LeadActionIcons
  phone={leadData?.phone}
  email={leadData?.email}
  onFileClick={() => setOpenFileDrawer(true)}
  onEditClick={internalEditLead}
  onFormResponseClick={() => getAllCustomFormResponse()}
  contactLinksGenerator={contactGenerator}
  hasCustomForms={leadData?.customForms?.length > 0}
  leadId={_id}
  leadName={name}
/>

            {/* Products button - below icons */}
            <button
  className="btn btn-outline-primary btn-sm d-flex align-items-center w-100 justify-content-center"
  style={{ fontSize: "12px", padding: "5px 10px", marginTop: "6px", marginBottom: "6px" }}
  onClick={() => setIsProductPickerOpen(true)}
>
  <ShoppingCart size={14} className="me-1" />
  {selectedProducts.length > 0 ? (
    <span>
      ₹ {(productTotal > 0 ? productTotal : Number(leadData?.saleValue || 0)).toLocaleString()}
      <span className="ms-1 badge bg-primary rounded-pill" style={{ fontSize: "10px" }}>
        {selectedProducts.length} {selectedProducts.length === 1 ? 'product' : 'products'}
      </span>
    </span>
  ) : (
    leadData?.saleValue ? `₹ ${Number(leadData.saleValue).toLocaleString()} - Add Products` : 'Add Products'
  )}
</button>

<DrawerComponent
  openWithHeader={openFileDrawer}
  setOpenWithHeader={() => setOpenFileDrawer(false)} // Direct setter function
  drawerTitle={`Files ${StoreData?.leadFile?.leadFile?.length || 0}`}
  size="sm"
>
  <FileUpload
    onLeadFileUpload={internalFileUpload}
    StateData={StateData}
    leadFileDelete={internalFileDeleteToggle}
    leadId={_id}
  />
</DrawerComponent>


        <LeadInfoPanel
  lead={{
    name: leadData?.name || name || "No Name",
    email: leadData?.email || selectedLeadData?.email || "",
    phone: leadData?.phone || selectedLeadData?.phone || "",
    status: (leadData?.status || status || []).filter((s: any) => s != null),
    labels: (leadData?.label || label || []).filter((l: any) => l != null).map((l: any) => ({
      value: typeof l === 'string' ? l : l.value || l,
      color: typeof l === 'object' ? l.color : undefined
    })),
    createdAt: leadData?.createdAt || createdAt,
    leadSource: (() => {
      const cs = leadData?.customSource || customSource || "";
      const intg = leadData?.integration || integration || "";
      // Resolve integration: can be object { name, key, ... } or a plain string
      const intgName = typeof intg === 'object' && intg !== null
        ? (intg.name || intg.key || "")
        : intg;
      // Use customSource if present, otherwise use integration name
      if (cs !== "") {
        return _.capitalize(cs.split("_").join(" "));
      }
      // Return integration name as-is (preserves casing for icon map matching)
      return typeof intg === 'object' && intg?.name ? intg.name : _.capitalize(String(intgName).split("_").join(" "));
    })(),
    createdBy: getEmployeeInfoById(leadData?.createdBy),
    assignedTo: getEmployeeInfoById(leadData?.assignedTo),
    list: leadData?.list ? getListInfoById(leadData?.list) : "",
    saleValue: leadData?.saleValue || saleValue,
    leadId: leadData?.sequencePrefix && leadData?.sequenceId
      ? `${leadData.sequencePrefix}-${leadData.sequenceId}`
      : undefined
  }}
  onStatusEdit={internalStatusClick}
  onLabelEdit={internalLabelClick}
  onAssignClick={() => setAssignLeadDrawer(true)}
/>
          </div>
        </div>
      </div>
      <div className="col-md-8">
        <div
          className="popup-section-4-right"
          style={{ padding: "14px 25px", height: "100%" }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <ul
            className="nav nav-pills d-flex gap-2"
            id="pills-tab"
            role="tablist"
            style={{ flex: 1, marginBottom: 0 }}
          >
            <li className="nav-item flex-fill" role="presentation">
              <button
                className="nav-link active"
                id="pills-activites-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-activites"
                type="button"
                role="tab"
                aria-controls="pills-activites"
                aria-selected="true"
                onClick={() => setActiveTab('activities')}
              >
                Activities ({leadData?.totalActivities || 0})
              </button>
            </li>
            <li className="nav-item flex-fill" role="presentation">
              <button
                className="nav-link"
                id="pills-task-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-task"
                type="button"
                role="tab"
                aria-controls="pills-task"
                aria-selected="false"
                onClick={() => setActiveTab('tasks')}
              >
                Tasks ({leadData?.totalTasks || 0})
              </button>
            </li>
            <li className="nav-item flex-fill" role="presentation">
              <button
                className="nav-link"
                id="pills-notes-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-notes"
                type="button"
                role="tab"
                aria-controls="pills-notes"
                aria-selected="false"
                onClick={() => setActiveTab('notes')}
              >
                Notes ({leadData?.totalNotes || leadData?.totalNote || 0})
              </button>
            </li>
            <li className="nav-item flex-fill" role="presentation">
              <button
                className="nav-link"
                id="pills-Info-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-Info"
                type="button"
                role="tab"
                aria-controls="pills-Info"
                aria-selected="false"
                onClick={() => setActiveTab('info')}
              >
                Info
              </button>
            </li>
          </ul>
          {activeTab !== 'info' && (
            <button
              className="lead-details-add-button"
              onClick={() => {
                if (activeTab === 'activities') { setAction("addActivity"); setOpenWithHeader(true); }
                else if (activeTab === 'tasks') { setAction("addTask"); setOpenWithHeader(true); }
                else if (activeTab === 'notes') { setAction("addNotes"); setOpenWithHeader(true); }
              }}
              style={{
                background: '#3faefd',
                border: 'none',
                borderRadius: '8px',
                color: '#fff',
                padding: '6px 12px',
                fontSize: '13px',
                fontFamily: '"Gilroy-Medium", "Gilroy", sans-serif',
                display: 'flex',
                alignItems: 'center',
                gap: '4px',
                cursor: 'pointer',
                whiteSpace: 'nowrap',
                flexShrink: 0,
                height: '32px',
              }}
            >
              <svg width="14" height="14" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.5 16.2C5.3105 16.2 1.9 12.969 1.9 9C1.9 5.031 5.3105 1.8 9.5 1.8C13.6895 1.8 17.1 5.031 17.1 9C17.1 12.969 13.6895 16.2 9.5 16.2ZM9.5 0C8.25244 0 7.0171 0.232792 5.86451 0.685084C4.71191 1.13738 3.66464 1.80031 2.78249 2.63604C1.00089 4.32387 0 6.61305 0 9C0 11.3869 1.00089 13.6761 2.78249 15.364C3.66464 16.1997 4.71191 16.8626 5.86451 17.3149C7.0171 17.7672 8.25244 18 9.5 18C12.0196 18 14.4359 17.0518 16.2175 15.364C17.9991 13.6761 19 11.3869 19 9C19 7.8181 18.7543 6.64778 18.2769 5.55585C17.7994 4.46392 17.0997 3.47177 16.2175 2.63604C15.3354 1.80031 14.2881 1.13738 13.1355 0.685084C11.9829 0.232792 10.7476 0 9.5 0ZM10.45 4.5H8.55V8.1H4.75V9.9H8.55V13.5H10.45V9.9H14.25V8.1H10.45V4.5Z" fill="white"/>
              </svg>
              {activeTab === 'activities' ? 'Add Activity' : activeTab === 'tasks' ? 'Add Task' : 'Add Note'}
            </button>
          )}
          </div>
          <div className="tab-content pt-2" id="myTabContent">
          <div
  className="tab-pane fade show active"
  id="pills-activites"
  role="tabpanel"
  aria-labelledby="activites-tab"
>
  <ActivityTab
    leadId={_id}
    totalActivities={leadData?.totalActivities || 0}
    onAddActivity={() => {
      setAction("addActivity");
      setOpenWithHeader(true);
    }}
    onEditActivity={(activityId, action) => {
      handleEditActivityModal('activity', activityId, action);
    }}
  />
</div>
            <div
              className="tab-pane fade"
              id="pills-task"
              role="tabpanel"
              aria-labelledby="task-tab"
            >
              <TaskDrawer
  openWithHeader={openWithHeader}
  setOpenWithHeader={setOpenWithHeader}
  drawerTitle={drawerTitle}
  size="xs"
>
             {(action === "addTask" || action === "editTask") && (
  <TaskForm
    leadId={_id} // This is now required
    updateTaskValue={taskData}
    action={action === "addTask" ? "add" : "edit"}
    status={""}
    
    drawerClose={() => {
      setOpenWithHeader(false);
      setAction("");
    }}
    fetchTaskStatusFollowUps={handleTaskFollowup}
  />
)}

                {(action === "addActivity" || action === "editActivity") && (
                  <CreateActivityForm
                    leadIds={[{ id: _id }]}
                    updateModalValue={activityData}
                    action={action === "addActivity" ? "Add" : "Edit"}
                    formName={"Activity"}
                    handleActivityFormSubmit={(data) => {
                      setOpenWithHeader(false);
                      setAction("");
                      if (data) {
                        setLeadData(data);
                      }
                    }}
                  />
                )}
                {(action === "addNotes" || action === "editNotes") && (
                  <CreateNoteForm
                    leadIds={[{ id: _id }]}
                    handleNotesSubmit={(data) => {
                      setOpenWithHeader(false);
                      setAction("");

                      if (data) {
                        setLeadData(data);
                      }
                    }}
                  />
                )}
              </TaskDrawer>
              <div
                className={
                  StateData?.leadTask?.leadTask?.length > 3
                    ? "row activity-scroll"
                    : "row"
                }
              >
                {StateData?.leadTask?.leadTask?.length > 0 ? (
                  StateData?.leadTask?.leadTask?.map((task: any, i: number) => (
                    <NewTaskItem
                      activity={task}
                      onEditTask={(info) => {
                        setAction("editTask");
                        setTaskData(info);
                        setOpenWithHeader(true);
                      }}
                    />
                  ))
                ) : (
                  <EmptyState
                    type="tasks"
                    actionLabel="Add Task"
                    onAction={() => {
                      setAction("addTask");
                      setOpenWithHeader(true);
                    }}
                  />
                )}
              </div>
            </div>
            <div
              className="tab-pane fade"
              id="pills-notes"
              role="tabpanel"
              aria-labelledby="notes-tab"
            >
              <div
                className={
                  StateData?.note?.notes?.length > 3
                    ? "row notes-scroll-flexible"
                    : "row"
                }
              >
                {StateData?.note?.notes?.length > 0 ? (
                  StateData?.note?.notes?.map((activity: any, i: number) => (
                    <LeadNoteItems activity={activity} key={i} />
                  ))
                ) : (
                  <EmptyState
                    type="notes"
                    actionLabel="Add Note"
                    onAction={() => {
                      setAction("addNotes");
                      setOpenWithHeader(true);
                    }}
                  />
                )}
              </div>
            </div>
            <div
              className="tab-pane fade"
              id="pills-Info"
              role="tabpanel"
              aria-labelledby="Info-tab"
            >
              <div className="d-flex justify-content-between align-items-center">
                {/* <h4 className=" mt-2">Lead Information</h4>
                <div>
                  <Button
                    size="small"
                    onClick={(e) =>
                      setDisableLeadInfo((prevState) => !prevState)
                    }
                  >
                    {disableLeadInfo ? (
                      <MdEdit title="Edit Changes" size={20} />
                    ) : (
                      <MdSave
                        onClick={() =>
                          (createLeadFormRef?.current as any)?.handleSubmit()
                        }
                        title="Save Changes"
                        size={20}
                      />
                    )}
                  </Button>
                </div> */}
              </div>
              {disableLeadInfo ? (
           <Information 
  leadToBeUpdate={_id}
  leadData={leadData}
/>
              ) : (
                <CreateLeadForm
                  isDetailsBox={true}
                  isEditMode={!disableLeadInfo}
                  disabled={disableLeadInfo}
                  showCreateNewLeadDrawer={() => {}}
                  getLeads={() => refreshData && refreshData()}
                  leadToBeUpdate={_id}
                  handleDrawerClick={() => {}}
                  selectedLeadId={leadListId || "0"}
                  leadList={StoreData.leadList.leadList}
                  ref={createLeadFormRef}
                  onClose={() => setDisableLeadInfo((prevState) => !prevState)}
                />
              )}
            </div>
          </div>
        </div>
      </div>
      <GenericConfirmationModal
        message="Are you sure you want to delete this task?"
        onConfirmation={handleDelete}
        showModal={showConfirmationModal}
        toggleModal={toggleConfirmationModal}
        title={action === "editTask" ? "Delete Task" : "Delete Activity"}
        confirmText="Delete"
        cancelText="Cancel"
        isWarning={true}
      />
      <GenericConfirmationModal
        message="Are you sure you want to delete this lead? This action cannot be undone."
        onConfirmation={handleDeleteLead}
        showModal={deleteModal}
        toggleModal={() => setDeleteModal(!deleteModal)}
        title="Delete Lead"
        confirmText="Delete"
        cancelText="Cancel"
        isWarning={true}
      />
      {/* Form Response Drawer */}
      <GlobalDrawer
        openWithHeader={viewFormResponse}
        setOpenWithHeader={() => {
          setViewFormResponse(false);
        }}
        drawerTitle="Form Response"
        size="lg"
      >
        {formData && (
          <FormResponse
            open={viewFormResponse}
            handleClose={() => {
              setViewFormResponse(false);
            }}
            formDetails={formData}
          />
        )}
      </GlobalDrawer>
      {/* Copy Lead */}
      <GlobalDrawer
        openWithHeader={copyLeadDrawer}
      
        setOpenWithHeader={() => {
          setCopyLeadDrawer(false);
        }}
        drawerTitle={activeLeadOption === "copy" ? "Copy Lead" : "Move Lead"}
        size="xs"
        customHeader
      >
        <label className="form-label">Select Destination lead list </label>
        <div>
          {leadListData?.length > 0
            ? leadListData?.map((item: any, ix: number) => {
                if (item._id != leadData.list) {
                  return (
                    <button
                      onClick={() => {
                        handleCopyLead(item._id);
                      }}
                      key={ix}
                      className="d-block bg-white w-100 p-3 rounded mb-2"
                      style={{ margin: "8px 0px", textAlign: "left" }}
                    >
                      {item.name}
                    </button>
                  );
                } else {
                }
              })
            : "No Record Found"}
        </div>
      </GlobalDrawer>

      {/* Assign Lead */}
    <AssignLeadDrawer
      isOpen={assignLeadDrawer}
      onClose={() => setAssignLeadDrawer(false)} 
      leadIds={[_id]} // Pass the current lead ID
      onAssignSuccess={(assignedToUser) => {
        // Update Redux store instead of making another API call
        const updatedLead = {
          ...leadData,
          assignedTo: assignedToUser
        };
        
        // Dispatch action to update the lead in Redux
        dispatch(updateSingleLead(updatedLead));
        
        // Also update local state if needed
        setLeadData(updatedLead);
        
        // Close the drawer
        setAssignLeadDrawer(false);
      }}
    />

  
      {isProductPickerOpen && (
  <MemoizedProductPickerPopup
    key={`product-picker-${selectedProducts
  .map(p => p?._id || 'missing')
  .join('-')}`}
    isOpen={isProductPickerOpen}
    onClose={handleClosePicker}
    onProductsSelect={handleProductsSelect}
    initialSelectedProducts={selectedProducts}
    
    excludeProductIds={[]}
    leadId={_id} // Pass the lead ID
    leadName={name} // Pass the lead name
    source="lead" 
  />
)}

{showBulkShareModal && (
  <BulkShareModal
    isOpen={showBulkShareModal}
    onClose={() => {
      setShowBulkShareModal(false);
      setContentData([]); // Clear data when closing
    }}
    selectedLeads={[leadData]} // Pass current lead as array
    contentTemplates={contentData} // Use local state, not Redux
  />
)}

{/* TODO: WhatsApp Conversations Feature - Component commented out for release */}
{/*
<LeadCommunicationPopup
  isOpen={showWhatsAppPopup}
  onClose={() => setShowWhatsAppPopup(false)}
  leadId={_id}
  leadName={name || "Unknown Lead"}
  leadPhone={leadData?.phone}
/>
*/}

{/* ========== SELF-CONTAINED INTERNAL COMPONENTS ========== */}
{/* These render only when external callbacks are not provided */}

{/* Internal Status Popup */}
<SelectLeadStatus
  showStatusPopup={internalStatusPopup}
  toggleLeadStatus={() => {
    setInternalStatusPopup(false);
    setInternalSelectedStatus("");
  }}
  onStatusChange={internalStatusChange}
  selectedStatus={internalSelectedStatus}
  setShowStatusPopup={setInternalStatusPopup}
  from={internalFrom}
  id={_id}
  leadList={leadListId || ""}
  getLeads={() => {
    fetchLeadDetails();
    refreshData?.();
  }}
  setOpenWithHeader={() => {}}
  onLeadUpdate={(updatedLead: any) => {
    if (updatedLead) {
      setLeadData(updatedLead);
    }
  }}
/>

{/* Internal Label Popup */}
<SelectLeadLabel
  showLabelPopup={internalLabelPopup}
  toggleLeadLabel={() => {
    setInternalLabelPopup(false);
  }}
  onLabelChange={internalLabelChange}
  selectedLabel={internalSelectedLabel}
  setShowLabelPopup={setInternalLabelPopup}
  from={internalFrom}
  id={_id}
  leadList={leadListId || ""}
  getLeads={() => {
    fetchLeadDetails();
    refreshData?.();
  }}
  setOpenWithHeader={() => {}}
  LabelData={internalLabelData}
  onLeadUpdate={(updatedLead: any) => {
    if (updatedLead) {
      setLeadData(updatedLead);
    }
  }}
/>

{/* Internal Edit Lead Drawer */}
<LeadDrawerComponent
  openWithHeader={internalEditDrawer}
  setOpenWithHeader={setInternalEditDrawer}
  drawerTitle="Update Lead"
  size="sm"
>
  <CreateLeadForm
    isDetailsBox={false}
    isEditMode={true}
    showCreateNewLeadDrawer={setInternalEditDrawer}
    getLeads={() => {
      fetchLeadDetails();
      refreshData?.();
    }}
    leadToBeUpdate={_id}
    handleDrawerClick={() => setInternalEditDrawer(false)}
    selectedLeadId={leadListId || "0"}
    leadList={StoreData?.leadList?.leadList || []}
  />
</LeadDrawerComponent>

{/* Internal File Delete Confirmation */}
<GenericConfirmationModal
  message="Are you sure you want to delete this file?"
  onConfirmation={internalFileDelete}
  showModal={internalFileDeleteModal}
  toggleModal={() => {
    setInternalFileDeleteModal(false);
    setFileToDelete(null);
  }}
  title="Delete File"
  confirmText="Delete"
  cancelText="Cancel"
  isWarning={true}
/>
{/* ========== END SELF-CONTAINED INTERNAL COMPONENTS ========== */}

    </div>
  );
};

export default LeadDetails;